/*
 * Authors: mariushirjanu
 * Created: 26/08/2022
 */
import { Component, ViewChild, ElementRef, OnInit, OnDestroy, Inject, Input, AfterViewInit } from '@angular/core';
import { IExtendedWindow } from '../../../type_definitions/datatypes';

/**
 * @ngdoc component
 * @name ga2.common.components.fixedToBottom:fixedToBottom
 *
 * @description A component for fixing an element to the bottom of the page when the height of the page becomes so big
 *              it would hide the said element. Uses jquery-scrolltofixed internally.
 */

@Component({
  selector: 'fixed-to-bottom',
  template: `
    <div #content>
      <div [class]="innerClass">
        <ng-content></ng-content>
      </div>
    </div>
  `
})
export class FixedToBottomComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('content', { static: true }) public content:ElementRef<HTMLDivElement>;
  @Input() public innerClass?:string;

  private childElement:JQuery;
  private visibleBackup:boolean;
  private visible:boolean;

  constructor(@Inject(Window) private window: IExtendedWindow) {
    /***/
  }

  public ngOnInit():void {
    this.childElement = $(this.content.nativeElement).children();
    this.listen();
  }

  public ngAfterViewInit(): void {
    setTimeout(() => {
      // do the first update after the view is initialised; wait some ms for width to be set
      this.updateElementFixation();
    }, 250);
  }

  private listen():void {
    // keep listening on scroll changes and window resize changes
    this.window.addEventListener('scroll', this.updateElementFixation, true);
    this.window.addEventListener('resize', this.updateElementFixation);
  }

  private updateElementFixation = ():void => {
    if (this.content) {
      const rect:DOMRect = this.content.nativeElement.getBoundingClientRect();
      const topShown:boolean = rect.top >= 0;
      const bottomShown:boolean = rect.bottom <= this.window.innerHeight;
      this.visible = topShown && bottomShown;

      if(this.visible !== this.visibleBackup){ // only when there is a visibility change
        if(!this.visible){
          this.addScrollToFixed();
        } else {
          this.removeScrollToFixed();
        }

        this.visibleBackup = this.visible;
      }
    }
  };

  private addScrollToFixed():void {
    this.childElement.scrollToFixed({ bottom: 0 });
  }

  private removeScrollToFixed():void {
    this.childElement.trigger('detach.ScrollToFixed');
  }

  public ngOnDestroy():void {
    this.window.removeEventListener('scroll', this.updateElementFixation, true);
    this.window.removeEventListener('resize', this.updateElementFixation);
    this.removeScrollToFixed();
  }
}